export enum SearchState {
    None,
    Searching,
    Found,
    Empty
}
